module.exports = __webpack_public_path__ + "static/img/top1_i3_nav.8e405c53.png";